import { Observable } from "rxjs"
import PoolGeneralInfo, { Pool } from "./RandomsModel/PoolData"
import { ObservableFromFetch } from "../ObservableFromFetch"

export interface MissedPeriodsData {
  PoolProgramID: number
  MakeUp: number
  TotalCompletedDrug: number
  TotalCompletedAlcohol: number
  AveragePoolSize: number
}

export default function PoolGeneralInfoGetObservable(poolId: number): Observable<PoolGeneralInfo> {
  const requestBody: string = new URLSearchParams({
    poolId: poolId.toString()
  }).toString()

  return ObservableFromFetch<PoolGeneralInfo>("RandomTest/GetPoolGeneralInformation?" + requestBody)
}

export function SetMissingPeriods(data: MissedPeriodsData) {
  const requestBody: string = JSON.stringify(data)

  return ObservableFromFetch<string>("RandomTest/SetMissingPeriodTest", requestBody)
}

export function PoolsGetObservable() {
  return ObservableFromFetch<Pool[]>("WorkforceRandomTest/GetPools")
}
